<template>
  <div>
    <div class="index-news">
      <div class="container">
          <div class="box clearfix">
              <div class="box-item">
                  <div class="inner titleChange">
                      <div class="title-box clearfix">
                          <div class="list">
                              <ul class="clearfix">
                                  <li class="active">科技热点</li>
                              </ul>
                          </div>
                          <div class="link">
                              <a href="http://www.bjrs.org.cn/list.aspx?m=66">
                                  <span>更多&nbsp;&gt;</span>
                              </a>
                          </div>
                          <div class="linebox"></div>
                      </div>
                      <div class="newsList">
                          <!--学者论述-->
                          <div class="child" style="display: block;" v-if="Groups[0]">
                              <ul>
                                  <li class="clearfix" v-for="(article , index) in  Groups[0].articles.slice(0,5)" :key="index">
                                      <div class="articleDate">
                                        <p class="artDay">{{getDay(article)}}</p>
                                        <p class="artMonth">{{getYearMonth(article)}}</p>
                                      </div>
                                      <div class="title" style="display:inline-block;    padding-left: 20px;">
                                        <p style="    font-size: 18px;font-family: PingFang SC;font-weight: bold;color: #353535;line-height: 37px;">
                                          <router-link
                                              :to="`/news/info/${article.plateid}/${article._id}`">{{article.title.length>28?article.title.slice(0,26)+'...':article.title}}</router-link>
                                        </p>
                                        <p style="font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #808080;line-height: 39px;">
                                          <router-link
                                              :to="`/news/info/${article.plateid}/${article._id}`">{{article.description}}</router-link>
                                        </p>
                                      </div>
                                  </li>
                              </ul>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="box-item">
                  <div class="inner titleChange">
                      <div class="title-box clearfix">
                          <div class="list">
                              <ul class="clearfix">
                                  <li class="active">培训信息</li>
                              </ul>
                          </div>
                          <div class="link">
                              <a href="http://www.bjrs.org.cn/list.aspx?m=67">
                                  <span>更多&nbsp;&gt;</span>
                              </a>
                          </div>
                          <div class="linebox"></div>
                      </div>
                      <div class="newsList">
                          <!--文化体育-->
                          <div class="child" style="display: block;" v-if="Groups[1]">
                              <ul>
                                  <li class="clearfix" v-for="(article , index) in  Groups[1].articles.slice(0,1)" :key="index" style="" style="height:169px;">
                                      <div class="articleImg">
                                        <img :src="`${global.remoteIp}/uploads/${article.picsrc}`" />
                                      </div>
                                      <div class="title"  style="display:inline-block;    padding-left: 20px;width:377px;margin-right: 0px;height:169px;"><p style="font-size: 18px;font-family: PingFang SC;font-weight: bold;color: rgb(53, 53, 53);line-height: 26px;width: 377px;line-height: 30px;">
                                          <router-link
                                              :to="`/news/info/${article.plateid}/${article._id}`">{{article.title.length>28?article.title.slice(0,26)+'...':article.title}}</router-link>
                                        </p>
                                        <p style="font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: rgb(128, 128, 128);white-space: initial;line-height: 22px;margin-top: 14px;">
                                          <router-link
                                              :to="`/news/info/${article.plateid}/${article._id}`">{{article.description?article.description.slice(0,136)+'...':article.title}}</router-link>
                                        </p>
                                      </div>
                                  </li>
                                  <li class="clearfix newbefore" v-for="(article , index) in  Groups[1].articles.slice(1,6)" :key="index" style=""><span class="date">{{article.addtime.slice(0,10)}}</span>
                                     <div class="title" style="height:50px;width: 405px;"><router-link
                                              :to="`/news/info/${article.plateid}/${article._id}`">{{article.title.length>28?article.title.slice(0,26)+'...':article.title}}</router-link>
                                      </div>
                                  </li>
                              </ul>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  props: {
    plates: Array,
    platename: String,
  },
  components: {},
  data() {
    return {
      articles: [],
      plateId: "",
      global,
       Groups: [
        {
          name: "科技热点", 
        },
        {
          name: "培训信息", 
        }
      ],
    };
  },
  mounted() {
    let watchflag = 0;
    for (let k = 0; k < this.Groups.length; k++) {
      for (let j = 0; j < this.plates.length; j++) {
        if (this.Groups[k].name == this.plates[j].name) {
          this.Groups[k].plateId = this.plates[j]._id;
          this.$axios
            .get(
              `/api/articles?plateid=${this.Groups[k].plateId}&sort=-createdAt&limit=7`
            )
            .then((res) => {
              if (res.data) {
                this.Groups[k].articles = this.global
                  .sortByTop(res.data.data);
                this.$forceUpdate();
              }
            });
          break;
        }
      }
    }
  },
   methods: {
    getDay(article) {
      let time =
        (article.addtime && article.addtime.replace(/-/g, "/")) ||
        article.createdAt;
      let now = new Date(time);
      return now.getDate();
    },
    getMonth(article) {
      let time =
        (article.addtime && article.addtime.replace(/-/g, "/")) ||
        article.createdAt;
      let now = new Date(time);
      return `${now.getMonth() + 1}`;
    },
    getYearMonth(article) {
      let time =
        (article.addtime && article.addtime.replace(/-/g, "/")) ||
        article.createdAt;
      let now = new Date(time);
      return `${now.getFullYear()}.${now.getMonth() + 1}`;
    },
  },
};
</script>
<style scoped>
@media screen and (min-width:480px) {
.xwscolf {
    width: 30%;
    float: left;
    height: auto;
    
}

.xwscolfc {
    width:  30%;
    float: left;
    height: auto;
    margin-left:5%;
}

.xwscolfr {
    width:  30%;
    float: right;
    height: auto;
}
/deep/ .el-card__body{
      padding: 25px;
}
}
.Inqclss{
    font-size: 33px;
    font-family: 黑体;
    font-weight: 600;
    color: #fff;
}
@media screen and (max-width:480px) {
  .xwscolf {
      width: 92%;
      height: auto;
      margin-bottom: 18px;
      left:4%;
      position: relative;
  }

  .xwscolfc {
      width:  92%;
      height: auto;
      margin-bottom: 18px;
      left:4%;
      position: relative;
  }

  .xwscolfr {
      width:  92%;
      height: auto;
      margin-bottom: 18px;
      left:4%;
      position: relative;
  }
  /deep/ .el-card__body{
      padding: 10px;
  }
  .Inqclss{
    font-size: 28px;
    font-family: 黑体;
    font-weight: 600;
    color: #fff;
  }
}



/deep/ .el-card.is-always-shadow, .el-card.is-hover-shadow:focus, .el-card.is-hover-shadow:hover{
  box-shadow: 0 2px 12px 0 rgb(206 26 18);
}
/deep/ .el-card{
  border: 1px solid #ce1a12;
}
.index-news .box-item{
  width: 50%;
}
.linebox{
    width: 100%;
    height: 2px;
    background: #306BCD;
    position: relative;
    top: 36px;
    }
.articleDate{
  display: inline-block;
  width: 72px;
height: 72px;
background: #F1F3F5;
border-radius: 4px;
    position: relative;
    top: -17px;
}
.articleImg{
    display: inline-block;
width: 173px;
height: 169px;
background: #F1F3F5;
border-radius: 4px;
    position: relative;
     top: -158px;

}

.artDay{
      font-size: 30px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #306BCD;
    line-height: 39px;
    text-align: center;
}
.artMonth{
  font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #808080;
    line-height: 22px;
    text-align: center;
}
.index-news .newsList .title{
  height: 72px;
      width: 493px;
margin-right: 0px;
}

</style>
